import * as React from "react";
import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import styles from "./style";
import { Box, Menu, MenuItem } from "@mui/material";

export default function CustomPagination({ pageCount, page, setPage, setRowsPerPage, totalItems, rowsPerPage = 10 }) {
  const [count, setCount] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRows, setSelectedRows] = useState(rowsPerPage);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (value) => {
    setAnchorEl(null);
    if (value) {
      setSelectedRows(value);
      setRowsPerPage(value);
    }
  };

  useEffect(() => {
    setSelectedRows(rowsPerPage);
  }, [rowsPerPage]);

  useEffect(() => {
    if (!pageCount || pageCount <= selectedRows) {
      setCount(1);
      return;
    }

    setCount(Math.ceil(pageCount / selectedRows));
  }, [pageCount, selectedRows]);

  return (
    <Stack spacing={2} sx={styles.container}>
      {totalItems > 0 &&

        <Box sx={styles.showBox}>
          <Typography sx={styles.show} >Show:</Typography>
          <Typography
            sx={{ ...styles.row, cursor: "pointer" }}
            onClick={handleClick}
          >
            {selectedRows} rows
          </Typography>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            {[10, 15, 20].map((option) => (
              <MenuItem key={option} onClick={() => handleMenuClose(option)}>
                {option} rows
              </MenuItem>
            ))}
          </Menu>
        </Box>
      }
      {totalItems > 0 &&
        <Pagination count={count} page={page} setPage={setPage} onChange={handleChange} sx={styles.pagination} />
      }
    </Stack>
  );
}
